/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { useRef } from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/coursera-plus-landing-page';

type Props = {
  messageOverride?: string;
  handleClose: () => void;
};

const NotEligibleForPromotionModal: React.FC<Props> = ({ handleClose, messageOverride }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { HeadingGroup, Content, Actions } = Dialog;
  const defaultEligibilityMessage = _t("Sorry, you're not eligible for this offer at this time.");
  return (
    <Dialog
      aria-describedby="dialog-content"
      open={true}
      variant="standard"
      onClose={handleClose}
      initialFocusRef={buttonRef}
    >
      <HeadingGroup>{_t('You are not eligible')}</HeadingGroup>
      <Content id="dialog-content">
        <Typography2 component="p">{messageOverride ?? defaultEligibilityMessage}</Typography2>
      </Content>
      <Actions>
        <Button size="medium" variant="primary" onClick={handleClose} ref={buttonRef}>
          {_t('Got it')}
        </Button>
      </Actions>
    </Dialog>
  );
};

export default NotEligibleForPromotionModal;
